import { Labores } from "./types";

export const state: Labores={
    horarioEmpleados : [],
    partesLocales:[]
}